"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonDataConnection = void 0;
var TokenizedServiceConnection_1 = require("./TokenizedServiceConnection");
var HttpMethod_1 = require("../HttpMethod");
var obtainer = function (result) {
    return { url: result.ServiceUrl, token: result.Token };
};
var CommonDataConnection = /** @class */ (function () {
    function CommonDataConnection(connection, errorCallback) {
        var _this = this;
        this.isCommonDataApiEnabled = function (enabledCallback, disabledCallback) {
            _this.tokenizedConnection.isEnabled(enabledCallback, disabledCallback);
        };
        this.callCommonDataApi = function (methodName, data, successCallback, unsuccessCallback) {
            _this.tokenizedConnection.callTokenizedApi(methodName, data, successCallback, unsuccessCallback);
        };
        this.tokenizedConnection = new TokenizedServiceConnection_1.TokenizedServiceConnection('ObtainCommonDataApiAccessToken', HttpMethod_1.HttpMethod.get, false, 'InvalidCommonDataToken', obtainer, connection, errorCallback);
    }
    return CommonDataConnection;
}());
exports.CommonDataConnection = CommonDataConnection;
